import { DISALLOWED_COLOR_VALUES as i } from "../../constants.js";
import e from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
let l = (r) => {
  if (r) {
    let t = e(r);
    if (t.isValid() && !i.includes(r))
      return t.toHexString();
  }
  return "";
};
export {
  l as getBackgroundColor
};
